"use client";

import "./globals.scss";
import { Provider } from "react-redux";
import PrelineScript from "./PrelineScript";
import store from "@/shared/redux/store";
import { Initialload } from "@/shared/contextapi";
import { useMemo, useState } from "react";
import { SnackbarProvider } from "./contexts/SnackbarContext";
import Snackbar from "./components/Snackbar";
import { SnackbarInitializer } from "./components/SnackbarInitializer";



import {AuthProvider} from "@propelauth/nextjs/client";

type ProvidersProps = {
  children: React.ReactNode;
};

export default function ProvidersClientLayout({ children }: ProvidersProps) {
     const [pageloading, setpageloading] = useState(false);
      const contextValue = useMemo(
        () => ({ pageloading, setpageloading }),
        // eslint-disable-next-line prettier/prettier
        [pageloading]
      );
  return (
    <>
      <AuthProvider authUrl={process.env.NEXT_PUBLIC_AUTH_URL!} refreshOnFocus={true}>
        <Provider store={store}>
            <Initialload.Provider value={contextValue}>
              <SnackbarProvider>
                <SnackbarInitializer />
                {children}
                <Snackbar />
              </SnackbarProvider>
            </Initialload.Provider>
        </Provider>
      </AuthProvider>
      <PrelineScript />
    </>
  );
}
